import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import NRTooltipContent from '../NRTooltipContent/NRTooltipContent';

function NRChip({ label, icon, tooltipTitle, tooltipContent, sx = {} }) {
  const theme = useTheme();
  const hasTooltip = Boolean(tooltipTitle || tooltipContent);

  const content = (
    <Box
      sx={{
        display: 'flex',
        padding: theme.spacing(0.5, 1),
        alignItems: 'center',
        gap: theme.spacing(0.5),
        borderRadius: theme.spacing(0.5),
        border: `1px solid ${theme.palette?.neutral?.[400] || theme.palette.divider}`,
        whiteSpace: 'nowrap',
        cursor: 'default',
        height: theme.spacing(3),
        boxSizing: 'border-box',
        flexShrink: 0,
        ...sx
      }}
    >
      {icon ? <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0, lineHeight: 0 }}>{icon}</Box> : null}
      <Typography variant="caption" color="textSecondary">
        {label}
      </Typography>
    </Box>
  );

  if (!hasTooltip) {
    return content;
  }

  return (
    <Tooltip
      tabIndex={0}
      title={<NRTooltipContent title={tooltipTitle} content={tooltipContent} />}
      placement="top"
      slotProps={{
        tooltip: {
          sx: {
            padding: theme.spacing(1, 1.5),
            backgroundColor: 'tooltip.background',
            borderRadius: theme.spacing(0.5),
            maxWidth: 300,
            overflow: 'visible'
          }
        }
      }}
    >
      {content}
    </Tooltip>
  );
}

export default NRChip;
